/* eslint-disable react/jsx-props-no-spreading */
import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import { useSearch } from 'wouter';
import queryString from 'query-string';
import { FormPanel, Link } from '@micromag/core/components';
import { useUrlGenerator, useRoutePush } from '@micromag/core/contexts';

import { getAbsoluteUrl } from '../../../lib/utils';
import { useOrganisation } from '../../../contexts/OrganisationContext';
import MainLayout from '../../layouts/Main';
import Page from '../../partials/Page';
import Footer from '../../partials/Footer';
import LoginForm from '../../forms/Login';

import styles from '../../../../styles/pages/auth/login.module.scss';

const propTypes = {
    className: PropTypes.string,
};

const defaultProps = {
    className: null,
};

const LoginPage = ({ className }) => {
    const url = useUrlGenerator();
    const push = useRoutePush();
    const search = useSearch();
    const organisation = useOrganisation();
    const { next = null } = queryString.parse(search);
    const onLoginComplete = useCallback(() => {
        if (next !== null) {
            window.location.href = getAbsoluteUrl(next);
        } else {
            push(url('home'));
        }
    }, [push, url]);

    const { name: organisationName = null } = organisation || {};

    return (
        <MainLayout contentAlign="middle">
            <Page
                title={
                    organisationName !== null ? (
                        <FormattedMessage
                            defaultMessage="Login to {name}"
                            description="Login page title"
                            values={{ name: organisationName }}
                        />
                    ) : (
                        <FormattedMessage defaultMessage="Login" description="Login page title" />
                    )
                }
                small
                className={classNames([
                    styles.container,
                    {
                        [className]: className !== null,
                    },
                ])}
            >
                <FormPanel>
                    <LoginForm onLoggedIn={onLoginComplete} />
                    <div className={styles.links}>
                        <Link href={url('auth.forgot_password')}>
                            <FormattedMessage
                                defaultMessage="Forgot password?"
                                description="Forgot password page link"
                            />
                        </Link>
                        {organisation === null ? (
                            <Link href={url('register')}>
                                <FormattedMessage
                                    defaultMessage="Register"
                                    description="Register page link"
                                />
                            </Link>
                        ) : (
                            <Link href={url('register')} external target="_self">
                                <FormattedMessage
                                    defaultMessage="Create an account on micromag.studio"
                                    description="Register page link"
                                />
                            </Link>
                        )}
                    </div>
                </FormPanel>
            </Page>
            <Footer />
        </MainLayout>
    );
};

LoginPage.propTypes = propTypes;
LoginPage.defaultProps = defaultProps;

export default LoginPage;
